defineDs('Shared/Framework/Mithril/Scripts/Helpers/RouteParam', [
  'Shared/Framework/Mithril/Scripts/Core/Mithril',
], function (m) {

  var sanitizeRouteParam = function (value, regex) {
    if (value === undefined || value === null) return value;
    return String(value).replace(regex, '');
  };

  var RouteParam = function (paramKey, sanitizeRoute = true, sanitizeRouteRegex = /[^a-zA-Z0-9_-]+/g) {
    // Early return, as we're not trying to set anything
    return function (value) {
      if (value === undefined) return sanitizeRoute ? sanitizeRouteParam(m.route.param(paramKey), sanitizeRouteRegex) : m.route.param(paramKey);
      var params = m.route.param();
      if (paramKey !== 'page') params.page = 1;

      var str = Object.keys(params).reduce(function (string, key) {
        var paramValue = key === paramKey ? value : params[key];
        if (sanitizeRoute) paramValue = sanitizeRouteParam(paramValue, sanitizeRouteRegex);
        return string + paramValue + '/';
      }, '/');
      m.route(str);
    };
  };

  return RouteParam;

});
